// src/pages/AdminDashboard.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import Sidebar from '../components/sidebar';
import Notification from '../components/Notification';
import ProfileDropdown from '../components/ProfileDropdown';
import '../styles/Dashboard.css';
// ✅ IMPORT KOMPONEN BARU


const AdminDashboard = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedUsername = localStorage.getItem('username');
        const isSuperAdmin = localStorage.getItem('is_super_admin') === 'true';

        if (!storedUsername || !isSuperAdmin) {
            alert('Akses ditolak. Anda bukan Super Admin atau belum login.');
            navigate('/login', { replace: true });
        } else {
            setUsername(storedUsername);
            setLoading(false);
        }
    }, [navigate]);

    if (loading || !username) {
        return <div>Memuat Panel Admin...</div>;
    }

    return (
        <div className="dashboard-container">
            <div className="dashboard-header">
                <div className="header-title">
                    <h2>Panel Admin - {username}</h2>
                </div>
                <div className="header-right">
                    <Notification username={username} />
                    <ProfileDropdown username={username} />
                </div>
            </div>

            <Sidebar />

            <div className="dashboard-content" style={{ marginLeft: '250px' }}>
                {/* ✅ Outlet akan merender komponen berdasarkan nested route di App.jsx
                  Namun, karena kita ingin langsung menampilkan SuperAdminTables saat mengakses /admin/tables,
                  kita perlu definisikan ini di App.jsx sebagai nested route.
                  Jika Anda ingin SuperAdminTables menjadi default di /admin, Anda bisa merendernya di sini:
                  <SuperAdminTables />
                  Tapi, karena Anda ingin ada "Registrasi Admin" juga, menggunakan Outlet adalah benar.
                */}
                <Outlet />
            </div>
        </div>
    );
};

export default AdminDashboard;